import React, { FC, useState } from 'react';

import usePrefix from 'utils/usePrefix';
import { FavoriteSchool } from 'utils/api/inbox';

import Modal from 'components/Modal';
import Button from 'components/Button';

import { ModalContent, SchoolList, SchoolItem, ModalButtons } from './styles';

interface Props {
  isOpen: boolean;
  schools: FavoriteSchool[];
  saving: boolean;
  onClose: () => void;
  onSave: (schoolIds: number[]) => void;
}

const FavoriteSchoolsModal: FC<Props> = ({ isOpen, schools, saving, onClose, onSave }) => {
  const t = usePrefix('InterventionPlans');
  const [selected, setSelected] = useState<Set<number>>(
    () => new Set(schools.filter((s) => s.isFavorite).map((s) => s.schoolId))
  );

  const toggle = (schoolId: number) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(schoolId)) next.delete(schoolId);
      else next.add(schoolId);
      return next;
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} small centered>
      <ModalContent>
        <h3>{t('favorite_modal_title')}</h3>
        <SchoolList>
          {schools.map((school) => (
            <SchoolItem key={school.schoolId}>
              <label>
                <input
                  type="checkbox"
                  checked={selected.has(school.schoolId)}
                  onChange={() => toggle(school.schoolId)}
                />
                {school.schoolName}
              </label>
            </SchoolItem>
          ))}
        </SchoolList>
        <ModalButtons>
          <Button label={t('favorite_cancel')} color="link" onClick={onClose} />
          <Button label={t('favorite_save')} disabled={saving} onClick={() => onSave(Array.from(selected))} />
        </ModalButtons>
      </ModalContent>
    </Modal>
  );
};

export default FavoriteSchoolsModal;
